export const reduceSelections = (selections, limit) => { 
        return selections.slice(0, limit);
}